import { render, staticRenderFns } from "./ChartItem.vue?vue&type=template&id=5a254f4e&scoped=true"
import script from "./ChartItem.vue?vue&type=script&lang=js"
export * from "./ChartItem.vue?vue&type=script&lang=js"
import style0 from "./ChartItem.vue?vue&type=style&index=0&id=5a254f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a254f4e",
  null
  
)

export default component.exports